import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { debounce, trim } from 'lodash';
import { debounceWrapper, parseErrorMessage } from '../../../util/util';

import styles from './InfoForm.scss';
import FormInput from '../../../components/FormInput';
import Button from '../../../components/Button';
import qmStyles from '../../../theme/qmStyles';
import ContactUs from '../components/ContactUs';
import Loader from '../../../components/Loader';

export default class OnboardingVerify extends Component {
  static propTypes = {
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    address: PropTypes.string.isRequired,
    postData: PropTypes.func.isRequired,
    navigateInfo: PropTypes.func.isRequired,
    error: PropTypes.object,
    loading: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    error: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      code: '',
    };

    this.postData = debounce(this.postData, 1337, {
      leading: true,
      trailing: false,
    });
  }

  setCode = e => {
    this.setState({
      code: e.target.value,
    });
  };

  postData = e => {
    e.preventDefault();
    const { postData, loading } = this.props;
    const { code } = this.state;
    if (!code) return;

    if (loading) return;

    postData(e, trim(code));
  };

  render() {
    const {
      firstName,
      lastName,
      email,
      address,
      navigateInfo,
      error,
      loading,
    } = this.props;
    const { code } = this.state;

    return (
      <form
        onSubmit={debounceWrapper(this.postData)}
        className={styles.container}
      >
        <div
          className={styles.mainForm}
          style={{ padding: qmStyles.doubleGutter }}
        >
          <h3 className={styles.title}>Confirmation</h3>
          <h3 style={{ paddingTop: 56 }} className={styles.title}>
            {firstName} {lastName}
          </h3>
          <h3 className={styles.title}>{address}</h3>
          <h3 className={styles.title}>{email}</h3>
          <h2
            className={styles.title}
            style={{
              paddingTop: 72,
              color: qmStyles.qmGreen,
              paddingBottom: qmStyles.halfGutter,
            }}
          >
            Property Verification Code
          </h2>

          <FormInput
            value={code}
            label="Enter Code"
            onChange={this.setCode}
            required
            error={!!error}
          />
          {!!error && (
            <p style={{ color: 'red', marginTop: 10 }}>
              {parseErrorMessage({ error })}
            </p>
          )}
          {loading ? (
            <div
              style={{
                height: 40,
                backgroundColor: 'white',
                border: `1px solid ${qmStyles.greyDark}`,
                width: '100%',
                marginTop: 52,
                marginBottom: qmStyles.gutter,
              }}
            >
              <Loader />
            </div>
          ) : (
            <FormInput
              type="submit"
              value="Next"
              style={{
                backgroundColor: qmStyles.qmGreen,
                width: '100%',
                color: 'white',
                lineHeight: 0,
                fontWeight: 'normal',
                marginTop: 52,
                marginBottom: qmStyles.halfGutter,
              }}
            />
          )}
          <Button
            text="Edit Info"
            onClick={navigateInfo}
            style={{ marginBottom: qmStyles.doubleGutter }}
          />
          <ContactUs />
        </div>
      </form>
    );
  }
}
